export default __webpack_public_path__ + "imgs/city_icon.svg";